import { makeStyles } from 'tss-react/mui';

const useStylesModalButtonBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  modalButtonBlock: {
    marginTop: 20,
    textAlign: 'center',
  },
  modalButtonBlockRight: {
    textAlign: 'right',
  },
  modalButtonBlockFixed: {
    position: 'sticky',
    width: 'calc(100% + 40px)',
    height: 72,
    bottom: -20,
    marginTop: 20,
    marginBottom: -20,
    marginLeft: -20,
    padding: '15px 20px',
    backgroundColor: theme.palette.common.white,
    borderTop: `1px solid ${theme.palette.info.main} !important`,
    zIndex: 15,
    [theme.breakpoints.down('md')]: {
      position: 'static',
    },
  },
  modalButtonBlockFixedMedium: {
    width: 'calc(100% + 40px)',
  },
}));

export default useStylesModalButtonBlock;
